import { useWorkspaceText } from '../interface-copy';
import { useCompany } from '@/company/context';
import { WorkspaceIcon } from '../icons';
import type { AgentListRow } from './api';

// What the agent canvas's tabs share (collaboration v1, PR 4 §7).

/** A canvas action: runs `work`, shows `done` (or the error), then reloads the agent. */
export type Act = (work: () => Promise<unknown>, done?: string) => Promise<void>;

/**
 * What `work` returns when the agent is no longer the viewer's to open after
 * it (archived, or made personal by an admin who is not its owner): the canvas
 * closes and the workspace shows `done`, instead of reloading into "no longer
 * available".
 */
export const CLOSES_CANVAS = 'closes-canvas';

// The viewer's company role: admins switch agents off and make them personal.
export function useIsCompanyAdmin() {
  const role = useCompany().data?.membership?.role;
  return role === 'owner' || role === 'admin';
}

export const when = (value: string | null | undefined, locale = 'en') =>
  value
    ? new Intl.DateTimeFormat(locale, { dateStyle: 'medium', timeStyle: 'short' }).format(
        new Date(value),
      )
    : '';

export function ScopeChip({ scope }: { scope: AgentListRow['scope'] }) {
  const { text: uiText, rich: uiRich } = useWorkspaceText();
  return (
    <span className="ws-agents-chip">
      <WorkspaceIcon name={scope === 'company' ? 'globe' : 'lock'} size={11} />
      {scope === 'company' ? uiText('Company') : uiText('Personal')}
    </span>
  );
}
